import { Theme } from 'shared/const/app';
import { createSlice, Dispatch, PayloadAction } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";
import { EMI } from 'shared/model/types';
import { AVAILABLE_LANGUAGES, Language } from "shared/const/languages";
import { logout } from './userSlice';

type ActivityState = {
    isActive: boolean;
    silent?: boolean;
};
type AppReducer = {
    activity: ActivityState;
    bottomSheet: boolean;
    currentEmi?: EMI;
    settings: {
        passcode_auth: boolean;
    };
    theme: Theme;
    language: Language;
};

const initialState: AppReducer = {
    activity: {
        isActive: false,
        silent: false,
    },
    settings: {
        passcode_auth: true,
    },
    bottomSheet: false,
    theme: Theme.System,
    currentEmi: EMI.Wallester,
    language: AVAILABLE_LANGUAGES.EN.id,
};

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setActivity: {
            reducer(state, action: PayloadAction<{ isActive: boolean; silent?: boolean }>) {
                state.activity.isActive = action.payload.isActive;
                state.activity.silent = action.payload.silent ?? false;
            },
            prepare(isActive: boolean, options?: { silent?: boolean }) {
                return { payload: { isActive, silent: options?.silent } };
            },
        },
        updateSettings(state, action: PayloadAction<Record<string, unknown>>) {
            state.settings = { ...state.settings, ...action.payload };
        },
        setBottomSheet(state, action: PayloadAction<boolean>) {
            state.bottomSheet = action.payload;
        },
        setTheme(state, action: PayloadAction<Theme>) {
            state.theme = action.payload;
        },
        setCurrentEmi(state, action: PayloadAction<EMI>) {
            state.currentEmi = action.payload;
        },
        setLanguage(state, action: PayloadAction<Language>) {
            state.language = action.payload;
        },
    },
    extraReducers: builder => {
        builder.addCase(PURGE, () => initialState);
        builder.addCase(logout, () => initialState);
    },
});

export const { setActivity, updateSettings, setBottomSheet, setTheme, setLanguage, setCurrentEmi } = appSlice.actions;
export default appSlice.reducer;

export const activityAction = (dispatch: Dispatch, action: Promise<unknown>, options?: { silent?: boolean }) => {
    dispatch(setActivity(true, options));
    action.finally(() => dispatch(setActivity(false)));
};

